import { onMounted, onUnmounted, watch, unref, isRef } from 'vue'

const scriptRegistry = new Map()

export function useJsonLd(schema, id = 'json-ld-default') {
  let scriptEl = null

  const apply = () => {
    const data = unref(schema)
    if (!data) {
      if (scriptEl) {
        scriptEl.remove()
        scriptRegistry.delete(id)
        scriptEl = null
      }
      return
    }

    if (!scriptEl) {
      scriptEl = document.createElement('script')
      scriptEl.type = 'application/ld+json'
      scriptEl.dataset.jsonLdId = id
      document.head.appendChild(scriptEl)
      scriptRegistry.set(id, scriptEl)
    }
    scriptEl.textContent = JSON.stringify(data)
  }

  onMounted(apply)

  if (isRef(schema)) {
    watch(schema, apply)
  }

  onUnmounted(() => {
    if (scriptEl) {
      scriptEl.remove()
      scriptRegistry.delete(id)
      scriptEl = null
    }
  })
}
